import {
  ADD_COMMENT_REQUEST_ASYNC,
  ADD_REPLY_REQUEST_ASYNC,
  COMMENTS_REQUEST_ASYNC,
  DELETE_COMMENT_REQUEST_ASYNC,
  EDIT_COMMENT_REQUEST_ASYNC,
  SAVE_NICKNAME_REQUEST_ASYNC,
  SET_REPORT_DATA,
  TOGGLE_COMMUNITY_TAB,
} from './constants'

const setReportData = (reportId, reportType, communityTab = false) => ({
  type: SET_REPORT_DATA,
  payload: { reportId, reportType, communityTab },
})
const toggleCommunityTab = (val) => ({
  type: TOGGLE_COMMUNITY_TAB,
  payload: { val },
})

const fetchComments = ({ background = false } = {}) => ({
  type: COMMENTS_REQUEST_ASYNC.INITIATE,
  payload: { background },
})
const fetchCommentsCancel = () => ({ type: COMMENTS_REQUEST_ASYNC.CANCEL })
export const fetchCommentsSuccess = (data) => ({
  type: COMMENTS_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchCommentsError = (error) => ({
  type: COMMENTS_REQUEST_ASYNC.ERROR,
  error,
})

const editComment = (commentId, newText) => ({
  type: EDIT_COMMENT_REQUEST_ASYNC.INITIATE,
  payload: { commentId, newText },
})
export const editCommentSuccess = () => ({
  type: EDIT_COMMENT_REQUEST_ASYNC.SUCCESS,
})
export const editCommentError = (error) => ({
  type: EDIT_COMMENT_REQUEST_ASYNC.ERROR,
  error,
})

const deleteComment = (commentId) => ({
  type: DELETE_COMMENT_REQUEST_ASYNC.INITIATE,
  payload: { commentId },
})
export const deleteCommentSuccess = () => ({
  type: DELETE_COMMENT_REQUEST_ASYNC.SUCCESS,
})
export const deleteCommentError = (error) => ({
  type: DELETE_COMMENT_REQUEST_ASYNC.ERROR,
  error,
})

const addComment = (text) => ({
  type: ADD_COMMENT_REQUEST_ASYNC.INITIATE,
  payload: { text },
})
export const addCommentSuccess = () => ({
  type: ADD_COMMENT_REQUEST_ASYNC.SUCCESS,
})
export const addCommentError = (error) => ({
  type: ADD_COMMENT_REQUEST_ASYNC.ERROR,
  error,
})

const addReply = (commentId, text) => ({
  type: ADD_REPLY_REQUEST_ASYNC.INITIATE,
  payload: { commentId, text },
})
export const addReplySuccess = () => ({ type: ADD_REPLY_REQUEST_ASYNC.SUCCESS })
export const addReplyError = (error) => ({
  type: ADD_REPLY_REQUEST_ASYNC.ERROR,
  error,
})

const saveCommunityUser = (nickname) => ({
  type: SAVE_NICKNAME_REQUEST_ASYNC.INITIATE,
  payload: { nickname },
})
export const saveCommunityUserSuccess = () => ({
  type: SAVE_NICKNAME_REQUEST_ASYNC.SUCCESS,
})
export const saveCommunityUserError = (error) => ({
  type: SAVE_NICKNAME_REQUEST_ASYNC.ERROR,
  error,
})

export default {
  // to props
  setReportData,
  toggleCommunityTab,
  fetchComments,
  fetchCommentsCancel,
  editComment,
  deleteComment,
  addComment,
  addReply,
  saveCommunityUser,
}
